import { fbt } from 'fbtee'
import { Clock } from 'lucide-react'
import { SettingsRow } from '../../components/SettingsCard'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select'
import { useTimeFormat } from '../../hooks/useTimeFormat'
import { formatClockTime, type HourCycle } from '../../lib/timeFormat'
import type { TimeFormatPref } from '@shared/preferences'

/** Same choice as the schedule settings' `TimeFormatSection`, plus a way back to auto. */
export function TimeFormatSettingsRow() {
  const { pref, autoHourCycle, locale, setPref } = useTimeFormat()
  const sample = (cycle: HourCycle) => formatClockTime('21:30', cycle, locale)

  return (
    <SettingsRow
      icon={<Clock className="size-4" />}
      label={
        <label htmlFor="settings-time-format">
          {fbt('Time format', 'Label for the Settings option choosing the 12-hour or 24-hour clock for set times')}
        </label>
      }
      trailing={
        <Select value={pref} onValueChange={v => setPref(v as TimeFormatPref)}>
          <SelectTrigger id="settings-time-format" data-testid="settings-time-format" className="w-40">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="auto">
              <fbt desc="Time format option that follows the phone's setting or the app language; the param is a sample time in the format it resolves to">
                Auto (<fbt:param name="sample">{sample(autoHourCycle)}</fbt:param>)
              </fbt>
            </SelectItem>
            <SelectItem value="12h">
              {fbt('12-hour', 'Schedule settings option for the 12-hour clock format')}{' '}
              <span className="tabular-nums text-muted-foreground">{sample('12h')}</span>
            </SelectItem>
            <SelectItem value="24h">
              {fbt('24-hour', 'Schedule settings option for the 24-hour clock format')}{' '}
              <span className="tabular-nums text-muted-foreground">{sample('24h')}</span>
            </SelectItem>
          </SelectContent>
        </Select>
      }
    />
  )
}
